import { DomainAutoRegluingsFormValidationSchema, DomainVisitors } from '../../../domains.interfaces';

export const domainAutoRegluingsFormValidationSchema: DomainAutoRegluingsFormValidationSchema = {
  forVisitor: [
    { required: true, message: 'Виберіть відвідувача' },
    {
      type: 'enum',
      message: 'Відвідувач має бути валідним значенням',
      enum: [DomainVisitors.Any, DomainVisitors.GoogleBot, DomainVisitors.Person]
    }
  ],
  isEnabled: [{ required: true, type: 'boolean' }]
};
